/**
 * Quem enviou um documento da Knowledge e por qual meio (AB#87121, AC11 e AC13).
 * Vem de `metadata.origin`, gravado pela api; documentos anteriores não têm.
 */
export type OriginChannel = "ui" | "external_agent" | "prodgy_chat" | "workspace_job" | "teams";

export interface DocumentOrigin {
  channel: OriginChannel | null;
  /** Pessoa que enviou, ou o agente quando foi um job de workspace. */
  author: string | null;
  /** O app conectado (ex.: Claude), quando o envio veio de um agente externo. */
  client: string | null;
  textOnly: boolean;
}

const CHANNELS: readonly OriginChannel[] = ["ui", "external_agent", "prodgy_chat", "workspace_job", "teams"];

function text(value: unknown): string | null {
  return typeof value === "string" && value.trim() ? value.trim() : null;
}

export function documentOrigin(metadata: unknown): DocumentOrigin | null {
  const origin = (metadata as { origin?: Record<string, unknown> } | null | undefined)?.origin;
  if (!origin || typeof origin !== "object") return null;
  const channel = CHANNELS.includes(origin.channel as OriginChannel) ? (origin.channel as OriginChannel) : null;
  return {
    channel,
    author: text(origin.user_name) ?? text(origin.agent_name),
    client: text(origin.client),
    textOnly: origin.content_mode === "text",
  };
}
